import React, { useState } from 'react'; //useEffect
import { observer, useLocalObservable } from 'mobx-react-lite';
import {
  Box,
  MainContent,
  TopContent,
  Content,
  TextButton,
  TextButtonDiv,
  Button,
  GrassButton,
  PlayArea as StyledPlayArea
} from "./styled";
import { useStore } from "../store";
import { APIClient } from '../api/client';
import RecordRTC from 'recordrtc';
import { MidiComponent } from './midi-messages'
import { useSkin } from '../styles/skins';

export const PlayArea = observer(() => {
  const store = useStore();
  const { currentSkin } = useSkin()
  const state = useLocalObservable(() => ({
    selectedSoundId: null,
    isRecording: false,
    recorder: null,
    get sounds() {
      return store.sounds;
    },

    get room() {
      return store.selectedRoom;
    },

    get workshop() {
      return store.workshops.length > 0 ? store.workshops[store.workshopCode].title : "";
    },

    playSound(sound) {
      this.selectedSoundId = sound?.id;
      if (sound.playbackMode === 'start_stop' || (sound.playbackMode === 'start_pause' && sound.playing)) {
        store.stopSound(sound.id, store.deviceId);
        sound.playing = false;
      } else {
        store.playSound(sound.id, store.deviceId);
        sound.playing = true;
      }
      sound.me = true;
    },

    get selectedSound() {
      return this.sounds.find(sound => sound.id === this.selectedSoundId)
    },

    startRecording() {
      navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
        this.recorder = new RecordRTC(stream, {
          type: 'audio',
          mimeType: 'audio/mp3'
        });
        this.recorder.startRecording();
        this.isRecording = true;
      }).catch(error => {
        console.error("Error starting recording:", error);
      });
    },

    stopRecording() {
      this.recorder.stopRecording(() => {
        // const blob = this.recorder.getBlob();
        // Save or send the recorded audio data
        this.isRecording = false;
      });
    }

  }));

  const [tags, setTags] = useState([]);
  const [newTag, setNewTag] = useState("");

  const handleAddTag = () => {
    if (newTag.trim() !== "") {
      setTags([...tags, newTag.trim()]);
      setNewTag("");
    }
  };

  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };

  const handleSaveTags = async (soundId) => {
    try {
      await APIClient.add_tags_to_sound(soundId, tags);
      alert("Tags saved successfully!");
    } catch (error) {
      console.error("Error saving tags:", error);
      alert("Failed to save tags.");
    }
  };

  // Check if there is more than one room in the workshop
  const multipleRooms = store.workshops[store.workshopCode].rooms.length > 1;

  return (
    <StyledPlayArea>
      {
        !store.roomSelected ? <>
            <TopContent>
              <h2>. . . . . </h2>
            </TopContent>
          </>
          :
          <>
            <TopContent>
              <h2>{state.room.title}</h2>
              <h2>Currently {store.isStaff ? <>
                    <Button disabled={!store.canChangeOnAirStatus} onClick={() => store.toggleOnAir()}>{store.onAir ? 'ON' : 'OFF'}-AIR</Button>
                  </> : <>{store.onAir ? 'ON' : 'OFF'}-AIR</>
                  }</h2>
              {store.isStaff && (
                <Button onClick={() => state.isRecording ? state.stopRecording() : state.startRecording()}>
                  {state.isRecording ? 'Stop Recording' : 'Start Recording'}
                </Button>
              )}
            </TopContent>

            <MainContent>
              {state.room.room_type !== 'midi' && (
                <Content>
                  <Box flex row>
                    {store.onAir ?
                      <>{state.sounds.map((sound, index) => (
                          <SoundButton
                            key={index.toString()}
                            value={index}
                            sound={sound}
                            playing={sound.playing}
                            loading={sound.loading}
                            me={sound.me}
                            onSelect={() => state.playSound(sound)}
                            tags={tags}
                            newTag={newTag}
                            setNewTag={setNewTag}
                            handleAddTag={handleAddTag}
                            handleRemoveTag={handleRemoveTag}
                            handleSaveTags={handleSaveTags}
                          />))}{state.sounds.length === 0 && (<>No sounds found.</>)}
                      </>
                      :
                      <>Not currently 'On Air'</>
                    }

                    {multipleRooms && (
                      <Box mt="2rem">
                        <p>There are multiple rooms available in this workshop. Please select one to join.</p>
                      </Box>
                    )}
                    {currentSkin === 'default' && (<GrassButton/>)}
                  </Box>
                </Content>
              )}
              {state.room.room_type === 'midi' && <MidiComponent />}
            </MainContent>
          </>
      }
    </StyledPlayArea>
  );
});

const SoundButton = observer(({ sound, loading, playing, me, onSelect, tags, newTag, setNewTag, handleAddTag, handleRemoveTag, handleSaveTags }) => {

  const renderButtonContent = () => {
    switch (sound.playbackMode) {
      case 'one_shot':
        return <TextButton truncated style={{ padding: '.8rem .5rem' }}>{sound.title}</TextButton>;
      case 'start_stop':
        return <TextButton style={{ padding: '.8rem .5rem' }}>{playing ? 'Stop' : 'Start'}</TextButton>;
      case 'start_pause':
        return <TextButton style={{ padding: '.8rem .5rem' }}>{playing ? 'Pause' : 'Play'}</TextButton>;
      case 'start_loop_stop':
        return <TextButton style={{ padding: '.8rem .5rem' }}>{playing ? 'Stop Loop' : 'Start Loop'}</TextButton>;
      default:
        return <TextButton style={{ padding: '.8rem .5rem' }}>Play</TextButton>;
    }
  };

  return (
    <div>
      <TextButtonDiv
        className={sound.playbackMode}
        loading={loading}
        playing={playing}
        me={me}
        onClick={() => onSelect(true)}
      >
        {renderButtonContent()}
      </TextButtonDiv>
    </div>
  );
});
